import { useApi } from './useApi';

export function useServicePrices() {
  const { fetchData, postData, putData } = useApi();
  const fetchServicePricesApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/service_prices', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const deleteServicePricesApi = async (id) => {
    try {
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const getServicePricesDetailApi = async (id) => {
      try {
          const result = await fetchData(`/api/service_prices/${id}?include=items,customer&searchJoin=AND`);
          return { success: true, data: result };
      } catch (err) {
          return { success: false, error: err.message || 'Lỗi kết nối' };
      }
  };

  const createServicePricesApi = async (credentials) => {
    try {
      const result = await postData('/api/service_prices', credentials);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const updateServicePricesApi = async (id, credentials) => {
      try {
          const result = await putData(`/api/service_prices/${id}`, credentials);
          return { success: true, data: result };
      } catch (err) {
          return { success: false, error: err.message || 'Lỗi kết nối' };
      }
  };

  return { fetchServicePricesApi, deleteServicePricesApi, createServicePricesApi, getServicePricesDetailApi, updateServicePricesApi };
}
